import './MiniSearch.scss';
import Component from './MiniSearch.js';
export default Component;